import React, { useState, useEffect } from 'react';
import { SideBar } from '../../layout';
import { useNavigate } from 'react-router-dom';
import * as mui from '@mui/material';
import ResponsiveContainer from '../../layout/Container';
import SearchAppBar from '../../common/Appbar';
import Separator from '../../layout/Separator';
import GridViewIcon from '@mui/icons-material/GridView';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import appService from '../../../services/ApplicationService';
import userService from '../../../services/UserService';
import companyService from '../../../services/CompanyService';
import { useParams } from 'react-router-dom';
import DynamicTabs from '../../common/DynamicTabs';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

const SysOwnerApplicationsUsers = () => {
    const [value, setValue] = React.useState(0);
    const [selectedNames, setSelectedNames] = useState([]);
    const { id } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const [roleFilter, setRoleFilter] = useState('all');
    const [statusFilter, setStatusFilter] = useState('all');
    const [filteredUsers, setFilteredUsers] = useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));

    const [users, setUsers] = useState([]);
    const [apps, setApps] = useState([]);
    const [selectedapps, setSelectedApps] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);

    // Apply filters to users
    const applyFilters = () => {
        let filtered = [...users];

        // Apply search term filter
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            filtered = filtered.filter(user => 
                (user.USER_ID && user.USER_ID.toLowerCase().includes(searchLower)) ||
                (user.EMAIL_ADDRESS && user.EMAIL_ADDRESS.toLowerCase().includes(searchLower)) ||
                (user.FIRST_NAME && user.FIRST_NAME.toLowerCase().includes(searchLower)) ||
                (user.LAST_NAME && user.LAST_NAME.toLowerCase().includes(searchLower)) ||
                (user.ROLE_NAME && user.ROLE_NAME.toLowerCase().includes(searchLower))
            );
        }

        // Apply role filter
        if (roleFilter !== 'all') {
            filtered = filtered.filter(user => user.ROLE_NAME === roleFilter);
        }

        // Apply status filter
        if (statusFilter !== 'all') {
            filtered = filtered.filter(user => {
                // Normalize the status comparison
                const userStatus = user.STATUS ? user.STATUS.trim() : '';
                const filterStatus = statusFilter.trim();
                return userStatus === filterStatus;
            });
        }

        // Only set filtered users if there are actual matches
        setFilteredUsers(filtered.length > 0 ? filtered : []);
    };

    // Update filtered users when filters change
    useEffect(() => {
        applyFilters();
    }, [searchTerm, roleFilter, statusFilter, users]);

    const tabs = [
        { 
          value: '1', 
          label: 'All Users', 
          content: (
            <div>
              <div style={{ marginBottom: '20px', display: 'flex', gap: '20px', alignItems: 'center' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search users..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Role</InputLabel>
                  <Select
                    value={roleFilter}
                    label="Role"
                    onChange={(e) => setRoleFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Roles</MenuItem>
                    <MenuItem value="Admin">Admin</MenuItem>
                    <MenuItem value="User">User</MenuItem>
                    <MenuItem value="Manager">Manager</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={statusFilter}
                    label="Status"
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Status</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <mui.TableContainer component={Paper}>
                {filteredUsers.length > 0 ? (
                  <mui.Table>
                    <mui.TableHead>
                      <mui.TableRow>
                        <mui.TableCell>User ID</mui.TableCell>
                        <mui.TableCell>Name</mui.TableCell>
                        <mui.TableCell>Email</mui.TableCell>
                        <mui.TableCell>Role</mui.TableCell>
                        <mui.TableCell>Status</mui.TableCell>
                      </mui.TableRow>
                    </mui.TableHead>
                    <mui.TableBody>
                      {filteredUsers.map((user, index) => (
                        <mui.TableRow key={index}>
                          <mui.TableCell>{user.USER_ID}</mui.TableCell>
                          <mui.TableCell>{`${user.FIRST_NAME} ${user.LAST_NAME}`}</mui.TableCell>
                          <mui.TableCell>{user.EMAIL_ADDRESS}</mui.TableCell>
                          <mui.TableCell>{user.ROLE_NAME}</mui.TableCell>
                          <mui.TableCell>{user.STATUS}</mui.TableCell>
                        </mui.TableRow>
                      ))}
                    </mui.TableBody>
                  </mui.Table>
                ) : (
                  <div style={{ 
                    padding: '20px', 
                    textAlign: 'center',
                    color: 'text.secondary'
                  }}>
                    <mui.Typography variant="h6">
                      No users found matching the selected filters
                    </mui.Typography>
                    <mui.Typography variant="body2" sx={{ mt: 1 }}>
                      Try adjusting your search criteria or filters
                    </mui.Typography>
                  </div>
                )}
              </mui.TableContainer>
            </div>
          ),
        },
        { 
          value: '2', 
          label: 'New Users', 
          content: (
            <div>
              <h2>Tab 2 Content</h2>
              <p>This is the content for Item Two.</p>
              <form>
                <label>
                  Name:
                  <input type="text" />
                </label>
                <button type="submit">Submit</button>
              </form>
            </div>
          ),
        },
        { 
          value: '3', 
          label: 'Termed Users', 
          content: (
            <div>
              <h2>Tab 3 Content</h2>
              <p>This is the content for Item Three.</p>
              <div>
                <img src="path_to_image.jpg" alt="Example" />
              </div>
            </div>
          ),
        },
        { 
            value: '4', 
            label: 'Administrators', 
            content: (
              <div>
                <h2>Tab 4 Content</h2>
                <p>Administrators.</p>
                <div>
                  <img src="path_to_image.jpg" alt="Example" />
                </div>
              </div>
            ),
          },
          { 
            value: '5', 
            label: 'Transfers', 
            content: (
              <div>
                <h2>Tab 5 Content</h2>
                <p>Transfers.</p>
                <div>
                  <img src="path_to_image.jpg" alt="Example" />
                </div>
              </div>
            ),
          },
      ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch apps and users in parallel
                const [appsResponse, usersResponse, currentUserresponse, companyResponse, appsByIdResponse] = await Promise.all([
                    appService.fetchApps(),
                    userService.fetchUsers(),
                    userService.fetchCurrentUser(),
                    companyService.fetchCompanies(),
                    appService.fetchAppsById(id)
                ]);
                
                setSelectedApps(appsByIdResponse)
                setUsers(usersResponse);
                setCurrentUser(currentUserresponse)
               
                const assignedAppResponse = await appService.fetchAppsByOwner(currentUserresponse.id)
                setApps(assignedAppResponse)

            } catch (error) {
                // Handle error appropriately (e.g., show error message to the user)
            }
        };

        fetchData();

        // Empty dependency array ensures this effect runs only once on mount
    }, []);


    const customMainContent = (
        <div>
            <ResponsiveContainer>

                <mui.Breadcrumbs aria-label="breadcrumb">
                    <mui.Link underline="hover" color="inherit" href="/dashboard">
                        <i className="material-icons">home</i>
                    </mui.Link>
                    <mui.Link underline="hover" color="inherit" href="/dashboard">
                        My Dashboard
                    </mui.Link>
                    <mui.Link underline="hover" color="inherit" href="/applications">
                        My Applications
                    </mui.Link>
                    <mui.Typography color="text.primary"> {selectedapps.APP_NAME}</mui.Typography>
                </mui.Breadcrumbs>

                <SearchAppBar  title={`${selectedapps.COMPANY_NAME} - ${selectedapps.APP_NAME}`} icon={<GridViewIcon />} />

                <mui.Typography sx={{ marginTop: '20px' }} variant="subtitle2" gutterBottom>
                    Manage, review, and download application user access data
                </mui.Typography>

                <Separator />

                <DynamicTabs tabs={tabs} />

                
            </ResponsiveContainer>
        </div>
    )

    return (
        <div>
            <SideBar mainContent={customMainContent} />
        </div>

    );
}
export default SysOwnerApplicationsUsers;